/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TransactionalEmailUserResponseDto } from './TransactionalEmailUserResponseDto';
export type TransactionalEmailResponseDto = {
  id: number;
  type: TransactionalEmailResponseDto.type;
  status: TransactionalEmailResponseDto.status;
  user: TransactionalEmailUserResponseDto;
  error?: string;
  email?: string;
  updatedAt: string;
  createdAt: string;
  parameters?: any;
};
export namespace TransactionalEmailResponseDto {
  export enum type {
    PASSWORD_CHANGE_REMIND_1 = 'PASSWORD_CHANGE_REMIND_1',
    PASSWORD_CHANGE_REMIND_2 = 'PASSWORD_CHANGE_REMIND_2',
    PASSWORD_CHANGE_REMIND_3 = 'PASSWORD_CHANGE_REMIND_3',
    DEVICE_COMMUNICATION_ERROR = 'DEVICE_COMMUNICATION_ERROR',
    INCIDENT = 'INCIDENT',
    API_KEYS_EXPIRATION_REMIND_1 = 'API_KEYS_EXPIRATION_REMIND_1',
    API_KEYS_EXPIRATION_REMIND_2 = 'API_KEYS_EXPIRATION_REMIND_2',
    API_KEYS_PERMISSIONS_CHANGE_REMIND_1 = 'API_KEYS_PERMISSIONS_CHANGE_REMIND_1',
    API_KEYS_PERMISSIONS_CHANGE_REMIND_2 = 'API_KEYS_PERMISSIONS_CHANGE_REMIND_2',
  }
  export enum status {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
  }
}

